module.exports = __webpack_public_path__ + "static/media/CNX-CNX-25.76061cba.png";